<template>
    <loading v-model:active="isLoading"
                 :can-cancel="false"
                 :opacity="0.7"
                 :is-full-page="false"/>
    <z-table
        ref="tbluser"
        title=""
        :headers="table.headers"
        :items="table.items"
        :meta="table.meta"
        class=""
    >
    </z-table>
</template>
<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        Loading
    },
    props: {
        items: [Array, Object],
        cari: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            // resourceurl: this.service_laporan + "kutipan/laporan/kaunter/kod_akaun",
            resourceurl: this.service_laporan +'kutipan/laporan/kaunter/kod_akaun?tarikh_dari=' +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&kaunter_id=" + this.cari.kaunter_id +
                    "&user_id=" + this.cari.user_id + 
                    // "&user_login_id=" + this.auth.user.id + 
                    "&user_login_id=" + this.$page.props.auth.user.id +
                    "&page=" + this.cari.page +
                    "&per_page=" + this.cari.per_page,
            reload: true,
            resit_id: null,
            isLoading: true,
        };


    },
    methods: {
    },
    watch: {
        table(){
            this.isLoading = false
        }
    },
    mounted() {

    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>